var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlltemplates({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 10L14 14L10 14L10 10L14 10ZM16 10H21L21 14H16L16 10ZM14 21L10 21V16L14 16V21ZM16 21V16H21V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H16ZM14 3L14 8L10 8V3L14 3ZM16 3L20 3C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V8H16L16 3ZM8 10L8 14L3 14L3 10H8ZM8 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20L3 16H8L8 21ZM8 3L8 8H3L3 4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3L8 3Z",
    fill: "#7771C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltemplates);
export default __webpack_public_path__ + "static/media/alltemplates.e545105939baa4bc6f101aba6767536e.svg";
export { ForwardRef as ReactComponent };